import 'shims';

import Collapse from 'bootstrap.native/dist/components/collapse-native.esm.js';
import Dropdown from 'bootstrap.native/dist/components/dropdown-native.esm.js';
import Modal from 'bootstrap.native/dist/components/modal-native.esm.js';

import { executeGoogleTagManager } from 'Google';

import Location from 'Browser/Location';
import { show, toggleAll } from 'Components/domHelpers';
import initNavbar from 'Components/navbar';

import initContact from './contact';

function load() {
  // abort the load if an error has already been displayed
  if (window.preLoader.loadErrorOccurred) {
    return;
  }

  const { loaderConfig } = window;

  window.preLoader.removeErrorHandlers();

  initNavbar();

  document
    .querySelectorAll('[data-toggle=collapse]')
    .forEach(el => new Collapse(el));

  document
    .querySelectorAll('[data-toggle=dropdown]')
    .forEach(el => new Dropdown(el));

  document
    .querySelectorAll('[data-toggle=modal]')
    .forEach(el => new Modal(el));

  const locationFilter = document.querySelector('.location-filter');
  if (locationFilter) {
    const onchange = () => {
      const { value } = locationFilter;

      toggleAll('.phone-number-table, .num-col', false);
      toggleAll('#india', !value || value === 'India');
      toggleAll('#tollfree', !value || [ 'China', 'United_Arab_Emirates', 'United_Kingdom' ].includes(value));

      if (value === '') {
        toggleAll('.phone-number-table, .num-col', true);
      } else {
        document
          .querySelectorAll(`.f_${value}`)
          .forEach(el => {
            show(el);
            show(el.parentNode);
          });
      }
    };

    locationFilter.onchange = onchange;

    const { country } = Location.query;
    if (country && country.match(/^[A-Z_]+$/i) &&
      locationFilter.querySelector(`option[value=${country}]`)) {
      locationFilter.value = country;
      onchange();
    }
  }

  initContact();

  if (loaderConfig && loaderConfig.GOOGLE_TAG_MANAGER_ID) {
    setTimeout(
      () => executeGoogleTagManager(loaderConfig.GOOGLE_TAG_MANAGER_ID), 50
    );
  }
}

window.addEventListener('load', load);
